import Vue from 'vue'
import Vuex from 'vuex'

// import globalAxios from 'axios'
// import router from '../router/index'

import { authStore } from './Auth/authStore'
import languageStore from './modules/languageStore'
import packageStore from './modules/packageStore'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

  },
  mutations: {

  },
  actions: {

  },
  getters: {

  },
  modules: {
    authStore,
    languageStore,
    packageStore
  }
})
